import { Fragment, useCallback, useState } from 'react';
import { Stack, Button, Box, Tooltip } from '@mui/material';
import { useSelector } from 'react-redux';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import Alert from '../common/Alert.component';
import DrawerComponent from '../common/Drawer.component';
import { Form } from '../form/Form';
import { fetchAPI } from '../../api/request';
import { useFormContext } from 'react-hook-form';

const SendMailButton = ({
    conf,
    apiSettings,
    defaultValues,
    buildPayload,
    disabled = false,
    disabledTooltip = 'Select at least one filter to send the email',
    successMessage = 'Success: Email sent!',
    tooltipTitle = 'Send Mail',
    onSuccess: externalOnSuccess = () => { },
    onError: externalOnError = () => { },
    children,
}) => {

    const { jwt } = useSelector((state) => state.login);

    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);

    const { fields, schema } = conf;

    const onSubmit = useCallback(
        (values) => {

            setLoading(true);
            setSuccess(false);
            setError(null);

            const payload = buildPayload ? buildPayload(values) : values;

            fetchAPI(apiSettings, {}, '', { data: payload }, jwt)
                .then((resp) => {
                    setLoading(false);
                    setSuccess(true);
                    externalOnSuccess(resp);
                })
                .catch((err) => {
                    setLoading(false);
                    setError(err);
                    externalOnError(err);
                });
        },
        [apiSettings, buildPayload, externalOnError, externalOnSuccess, jwt]
    );

    const SubmitButton = () => {
        const { formState: { isValid } } = useFormContext();
        return (
            <Box display='flex' justifyContent='right' alignItems='center'>
                <Button
                    type='submit'
                    variant='contained'
                    disabled={loading || !isValid}
                    autoFocus
                >
                    Send email
                </Button>
            </Box>
        );
    };

    return (
        <Fragment>
            {success && <Alert severity='success'>{successMessage}</Alert>}

            {error && (
                <Alert severity='error'>
                    {error?.response?.data?.error?.message || error?.message || 'An error has occurred'}
                </Alert>
            )}

            {disabled ? (
                <Tooltip title={disabledTooltip}>
                    <span>
                        <Button
                            disabled
                            variant='contained'
                            size='small'
                            sx={{ maxWidth: 150 }}
                            startIcon={<ForwardToInboxIcon />}
                        >
                            Send email
                        </Button>
                    </span>
                </Tooltip>
            ) : (
                <DrawerComponent
                    button={
                        <Stack direction='row' alignItems='center' spacing={1}>
                            <Tooltip title={tooltipTitle}>
                                <span>
                                    <Button
                                        variant='contained'
                                        size='small'
                                        sx={{ maxWidth: 150 }}
                                        startIcon={<ForwardToInboxIcon />}
                                    >
                                        Send email
                                    </Button>
                                </span>
                            </Tooltip>
                        </Stack>
                    }
                >
                    <Stack spacing={2} justifyContent='center' alignItems='center' width={1}>
                        <Form
                            fields={fields}
                            schema={schema}
                            defaultValues={defaultValues}
                            onSubmit={onSubmit}
                        >
                            {children}
                            <SubmitButton />
                        </Form>
                    </Stack>
                </DrawerComponent>
            )}
        </Fragment>
    );
};

export default SendMailButton;